<template>
  <v-timeline dense v-if="chamada.acao">
    <v-timeline-item small color="orangePcm" fill-dot>
      <v-card color="background">
        <v-row dense>
          <v-col cols="12">
            <v-card-title>{{ titleObject[`${chamada.status}`] }}</v-card-title>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Data: </strong>
              {{ timeToDate(chamada.dateStartCall) }}
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Origem: </strong>
              {{ chamada.numeroOrigem }}
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Destino: </strong>
              {{ chamada.numeroDestino }}
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Ação: </strong>
              {{ actionObject[`${obtemAcao(chamada.acao)}`] }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-divider class="ma-2" />
        <v-row align="center" align-content="center" dense>
          <v-col cols="2">
            <v-card-text>
              <strong>{{ obtemAcao(chamada.acao) === 'DiscarConferencia' ? 'Conferência: ' : 'Atendente: ' }}</strong>
              {{
                verificaTronco(chamada.atdCall, chamada.numeroOrigem, chamada.numeroDestino, obtemAcao(chamada.acao))
              }}
            </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text>
              <strong>Centro de Custos: </strong>
              {{ `${chamada.centroDeCusto.codigo} - ${chamada.centroDeCusto.description}` }}
            </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text> <strong>Status: </strong> {{ statusObject[`${chamada.status}`] }} </v-card-text>
          </v-col>
          <Player
            v-if="permissaoOuvirChamada"
            :acao="obtemAcao(chamada.acao)"
            :archive="
              obtemAcao(chamada.acao) === 'DiscarConferencia'
                ? `${chamada.atdCall}-${chamada.uniqueidCall}-${chamada.linkedid}.wav`
                : chamada.records[0]
            "
            :file="
              obtemAcao(chamada.acao) === 'DiscarConferencia'
                ? getAudioConference(`${chamada.atdCall}-${chamada.uniqueidCall}-${chamada.linkedid}.wav`)
                : getAudio(chamada.records[0])
            "
            downloadable
            color="primary"
          />
        </v-row>
      </v-card>
    </v-timeline-item>
    <div v-if="chamada.eventos">
      <div v-for="(evento, key) in chamada.eventos" :key="key">
        <TimeLineTransferenciaConf
          v-if="evento.acao && evento.acao.split('\\')[evento.acao.split('\\').length - 1] === 'DiscarConferencia'"
          :evento="evento"
        />
        <TimeLineEventoTransferencia
          v-else-if="evento.tipoChamada === 'transferencia'"
          :evento="evento"
          isFrom="pesquisaSatisfacao"
        />
        <TimeLineBlindTransfer
          v-else-if="evento.tipoChamada === 'BLINDTRANSFER'"
          :evento="evento"
          isFrom="pesquisaSatisfacao"
        />
      </div>
    </div>
    <v-timeline-item color="orangePcm" fill-dot small v-if="chamada.status === 'atendida'">
      <v-card>
        <v-row dense>
          <v-col cols="12">
            <v-card-title>
              Final Ligação
            </v-card-title>
          </v-col>
        </v-row>
        <v-row align="center" align-content="center" dense>
          <v-col>
            <v-card-text> <strong>Data final: </strong> {{ timeToDate(chamada.dateEndCall) }} </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Desligado por: </strong>
              {{ ligacaoCaiu(chamada.hangupSource, chamada.numeroDestino) }}
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Tempo Total: </strong>
              {{ obtemTempo(chamada.dateEndCall, chamada.dateStartCall) }}
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-text>
              <strong>Conversação: </strong>
              {{ obtemTempo(chamada.dateEndCall, chamada.dataAtdCall) }}
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

import { hostname } from '@/utils/hostname'
import { registerVuexModule } from '@/utils/vuexUtils'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'
import TimeLineBlindTransfer from '@/modules/PABX/modules/relatorios/modules/chamadas/_components/TimeLineBlindTransfer'
import TimeLineEventoTransferencia from '@/modules/PABX/modules/relatorios/modules/chamadas/_components/TimeLineEventoTransferencia'
import TimeLineTransferenciaConf from '@/modules/PABX/modules/relatorios/modules/chamadas/_components/TimeLineTransferenciaConf'
import Player from '@/modules/PABX/modules/relatorios/modules/chamadas/_components/Player'

import relatorioDetalhadoPesquisaSatisfacaoStore from '../_store'

export default {
  components: { TimeLineBlindTransfer, TimeLineEventoTransferencia, TimeLineTransferenciaConf, Player },
  data: () => ({
    titleObject: {
      atendida: 'Status Atendimento: Atendida',
      ocupado: 'Status Atendimento: Ocupado',
      acessoNegado: 'Status Atendimento: Acesso Negado',
      naoAtendida: 'Status Atendimento: Não Atendida',
      error: 'Status Atendimento: Erro',
      outros: 'Status Atendimento: Outros',
      pending: 'Status Atendimento: Pendente',
    },
    statusObject: {
      atendida: 'Atendida',
      ocupado: 'Ocupado',
      acessoNegado: 'Acesso Negado',
      naoAtendida: 'Não Atendida',
      error: 'Erro',
      outros: 'Outros',
      pending: 'Pendente',
    },
    actionObject: {
      DiscarGrupo: 'Discar para grupo de atendimento',
      DiscarRamal: 'Discar para ramal',
      DiscarTronco: 'Discar para tronco',
      TocarUra: 'Discar para URA',
      TocarSinalDeOcupado: 'Tocar sinal de ocupado',
      TocarAudio: 'Tocar áudio',
      ValidarSenha: 'Validar senha',
      ChangeToTrueActiveRegex: 'Ativar expressão regular',
      ChangeToFalseActiveRegex: 'Desativar expressão regular',
      DiscarFila: 'Discar para fila',
      DiscarAgente: 'Discar para operador',
      DiscarConferencia: 'Discar para conferência',
    },
    arrayPermissionsHearCallAudio: [
      process.env.VUE_APP_ADMINISTRADOR,
      process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_TOTAL,
      process.env.VUE_APP_PESQUISA_SATISFACAO_RELATORIO_OUVIR_GRAVACAO_HISTORICO,
    ],
    permissaoOuvirChamada: false,
  }),

  computed: {
    ...mapGetters('relatorioDetalhadoPesquisaSatisfacaoStoreModulePesquisaSatisfacao', [
      'getDescriptionSpecificConferencia',
      'getDadosChamada',
    ]),
    chamada() {
      return this.getDadosChamada
    },
  },

  async created() {
    registerVuexModule(
      this.$store,
      'relatorioDetalhadoPesquisaSatisfacaoStoreModulePesquisaSatisfacao',
      relatorioDetalhadoPesquisaSatisfacaoStore
    )

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()
    arrayPermissions.forEach(permissionLocalStorage => {
      if (this.arrayPermissionsHearCallAudio.includes(permissionLocalStorage)) {
        this.permissaoOuvirChamada = true
      }
    })

    await this.listarConferencias()

  },

  methods: {
    ...mapActions('relatorioDetalhadoPesquisaSatisfacaoStoreModulePesquisaSatisfacao', ['listarConferencias']),
    ...obtainUserPermissions,

    getAudio(audio) {
      return `https://${hostname()}/backend/asterisk/gravacao/player/${audio}`
    },
    getAudioConference(audio) {
      return `https://${hostname()}/backend/asterisk/relatorios/download/conferencia/${audio}`
    },

    verificaTronco(atendente, numeroOrigem, numeroDestino, acao) {
      if (acao === 'DiscarConferencia' && atendente) {
        return this.getDescriptionSpecificConferencia(atendente)
      }
      if (acao === 'DiscarConferencia' && !atendente) {
        return 'Pendente'
      }

      if (typeof atendente === 'undefined') {
        return 'Não atendida'
      }
      if (acao === 'DiscarFila') {
        return atendente.split('-')[2]
      }
      if (atendente.includes('Local')) {
        return atendente.split('@')[0].split('/')[1]
      }
      if (typeof atendente.split('-')[1] === 'undefined') {
        return atendente
      }

      if (typeof atendente.split('-')[2] !== 'undefined') {
        return `${atendente.split('-')[0]} - ${atendente.split('-')[1]}`
      }

      const verificacao = atendente.split('-')[0].includes('.')
      if (!verificacao) {
        return atendente.split('-')[0].split('/')[1]
      }
      if (numeroOrigem.length >= 8) {
        return numeroOrigem
      }
      return numeroDestino
    },

    ligacaoCaiu(hangupSource, numeroDestino) {
      if (hangupSource.includes('PJSIP/')) {
        if (hangupSource.includes('.')) {
          return numeroDestino
        }
        return hangupSource.split('-')[0].split('/')[1]
      }

      return hangupSource
    },

    timeToDate(date) {
      return moment(date, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY HH:mm')
    },

    obtemAcao(acao) {
      if (typeof acao !== 'undefined') {
        const lastPositionArray = acao.split('\\').length - 1
        return acao.split('\\')[lastPositionArray]
      }

      return
    },

    obtemTempo(tempoFinal, tempoInicial) {
      const tempoTotalChamada = moment(tempoFinal, 'YYYY-MM-DD HH:mm:ss').diff(
        moment(tempoInicial, 'YYYY-MM-DD HH:mm:ss')
      )
      const d = moment.duration(tempoTotalChamada)
      const tempo = Math.floor(d.asHours()) + moment.utc(tempoTotalChamada).format('H:mm:ss')
      return tempo
    },
  },
}
</script>
